<div class="dashboard-boxes-head"
     [ngClass]="['dashboard-boxes-head--theme-' + data.color, (hasSort) ? 'dashboard-boxes-head--has-sort' : '']">
  <div class="dashboard-boxes-head__title">
    <brt-icon *ngIf="data.titleIcon.length" [icon]="data.titleIcon"></brt-icon>
    <span>{{data.title}}</span>
    <div class="dashboard-boxes-head__title-amount" [ngClass]="{'zero': data.titleAmount === 0}" *ngIf="data.titleAmount !== undefined">
      {{data.titleAmount}}
    </div>

    <div class="dashboard-boxes-head__tooltip" *ngIf="data.tooltip.length > 0">
      <brt-icon [icon]="'circle-infos'" brtTooltip [text]="data.tooltip"></brt-icon>
    </div>
  </div>



  <div class="dashboard-boxes-head__actions" *ngIf="data.menuItemActions.length" brtItemActions [items]="data.menuItemActions" [add-hover-effect]="true">
    <brt-icon [icon]="'dotting'"></brt-icon>
  </div>

  <div class="dashboard-boxes-head__hint" *ngIf="data.hint.length" (click)="onHintClick()">
    <brt-icon *ngIf="data.hintIcon.length > 0" [icon]="data.hintIcon" [add-blur]="true"></brt-icon>
    <div class="dashboard-boxes-head__hint-circle" *ngIf="data.addHintPulseCircle"></div>
    <span>{{data.hint}}</span>
    <div class="dashboard-boxes-head__hint-sort-icon">
      <brt-icon [icon]="'dropdown'" *ngIf="data.hintSort === 'DESC'"></brt-icon>
      <brt-icon [icon]="'dropup'" *ngIf="data.hintSort === 'ASC'"></brt-icon>
    </div>
  </div>
</div>
